module.exports = __webpack_public_path__ + "img/nose-06.5ac8b9f0.svg";